import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeProfitWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.profit",
  name: "Net profit",
  description: "Net profit for the selected dashboard period.",
  apps: [
    "home",
    "finance",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "value",
        },
      ],
      where: {
        type: "group",
        operator: "or",
        children: [
          {
            type: "condition",
            field: "account_type",
            operator: "starts_with",
            value: "income",
          },
          {
            type: "condition",
            field: "account_type",
            operator: "starts_with",
            value: "expense",
          },
        ],
      },
    },
  },
  inputs: {
    label: "Net profit",
    subtext: "",
    icon: "trend",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: -1,
  },
  dummyData: {
    value: "$14,400",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
